import {Redirect} from "react-router-dom";
import * as React from "react";

import {cs} from "@Common/react/chain-services";

import {ApmPrefsRoute}           from "./apm-prefs/apm-prefs-route";
import {ScheduledCampaignsRoute} from "./scheduled-campaigns-1/scheduled-campaigns-route";

const ProgramDefaultsRerouter = () => cs(
    ({}) => (
        <Redirect to="/account/program-defaults/apm-prefs" />
    ),
);
const ApmPrefsRerouter = () => cs(
    ({}) => (
        <Redirect to="/account/program-defaults/apm-prefs/postcards" />
    ),
);

export const ProgramDefaultsComponents: React.ComponentType<any>[] = [
    ApmPrefsRoute,
    ApmPrefsRerouter,
    ProgramDefaultsRerouter,
    ScheduledCampaignsRoute,
];
